// CANONICAL COPY: installations\smart-td\content\adverseAuthorityTable.js (ruling 321 slice 3c, task list section 737). src\data\adverseAuthorityTable.js is its
// projection, written by scripts\sync-installation.js - EDIT THE CANONICAL. An edit made only to the projection is refused by the cycle.
// DATA ONLY (section 737): lifted verbatim out of src\data\adverseAuthority.js, which keeps the code and re-exports every name here.
const BN = /\b(BN|BNSF|Burlington\s+Northern)\b/i;
const PLB7303_BOARD =
  'PLB 7303 - Neutral: Robert M. O’Brien; Carrier Member: Jason Ringstad; ' +
  'Employee Member: Matthew L. Burkart (GC, GO-341)';
const PLB7303_PROV = 'Supplied by M. Burkart, GC GO-341, 2026-08-24. Read on the page 2026-08-28.';
const PLB7303_DOC = 'data\\PLB7303_Awards_6-13_with_dissents.pdf';

export const ADVERSE_AUTHORITY = [
  // ---------------------------------------------------------------------------------------------
  // ADDED 2026-08-28 on Bob's instruction ("yes, add them"). Awards 6, 7 and 10, read on the page
  // and graded at data\YCP_PLB7303_AWARDS_6_10_12_2026-08-28.md.
  //
  // AWARD 12 IS DELIBERATELY NOT HERE. It was SUSTAINED - favourable to the Organization - and this
  // table is the ADVERSE-authority gate. A favourable award belongs in a precedent surface, not in a
  // warning. Putting it here would tell a member an award is against him when it is for him.
  //
  // AND THIS IS NO LONGER ONLY A COMMENT. Verifier check AWD-1 fails the build if any award in this
  // table carries Outcome SUSTAINED in data\YCP_Precedent_Index.csv. Adding Award 12 back will not
  // pass. That was tested by actually adding it - the check caught it - and not by reading the code.
  // ---------------------------------------------------------------------------------------------
  {
    id: 'PLB7303-06',
    appliesTo: BN,
    // Procedural. Fires where a claim leans on the 48-hour exchange or on notice defects.
    subject: /rule\s*22|48[-\s]?hour|notice\s+of\s+investigation|investigation\s+notice|charge\s+letter|due\s+process|fair\s+and\s+impartial/i,
    citation: 'Public Law Board No. 7303, Award No. 6 (3 July 2018)',
    board: PLB7303_BOARD,
    subjectMatter:
      'Whether a Rule 22 breach - witness statements, a special agent’s report and photographs not ' +
      'furnished 48 hours before the investigation - invalidates the discipline.',
    outcome: 'ADVERSE to the Organization on the PROCEDURE point.',
    readingState: 'MAJORITY OPINION READ 2026-08-28',
    caveat:
      'This Board did NOT dispute the Rule 22 breach. It EXCUSED it, on a no-prejudice test: the ' +
      'statement-writers testified, the report held nothing new, and the photographs were not new ' +
      'evidence because the claimant admitted the damage. SO A BARE TIMING BREACH IS NOT ENOUGH ' +
      'BEFORE THIS BOARD - plead what the late material contained that the member could not answer. ' +
      'Note also that the notice charged the CONDUCT ("quarrelsome", "discourteous") without naming ' +
      'the rule, and the Board held that sufficient notice.',
    document: PLB7303_DOC,
    provenance: PLB7303_PROV,
  },
  {
    id: 'PLB7303-07',
    appliesTo: BN,
    subject: /vacation|profit\s*shar|compensation\s+earned|regular\s+earnings|1\/52/i,
    citation: 'Public Law Board No. 7303, Award No. 7 (3 July 2018)',
    board: PLB7303_BOARD,
    subjectMatter:
      'Whether a profit sharing payment is "compensation earned" and must be included in the 1/52 ' +
      'calculation of vacation pay.',
    outcome: 'ADVERSE to the Organization.',
    readingState: 'MAJORITY OPINION READ 2026-08-28',
    caveat:
      'SCOPE WARNING, and it is the reason this row is worth carrying. Unlike every other entry in ' +
      'this table, the reasoning is NOT BN-specific: the Board construed ARTICLE VIII OF THE 2002 ' +
      'NATIONAL AGREEMENT. `appliesTo` is held to BN because Bob’s doctrine bars citing another ' +
      'property’s material - but A CARRIER IS UNDER NO SUCH RESTRAINT and may raise it elsewhere. ' +
      'The Board also leaned on thirteen years of unrebutted contrary practice, and expressly held ' +
      'that the IRS treating profit sharing as income is irrelevant.',
    document: PLB7303_DOC,
    provenance: PLB7303_PROV,
  },
  {
    id: 'PLB7303-10',
    appliesTo: BN,
    subject: /dishonest|pay\s*ticket|time\s*claim|falsif|PEPA|waiver|review\s+period|mileage/i,
    citation: 'Public Law Board No. 7303, Award No. 10 (3 July 2018)',
    board: PLB7303_BOARD,
    subjectMatter:
      'Whether dismissal was warranted where a pay ticket overstated the day by about one hour and ' +
      'the claimant was inside a PEPA review period.',
    outcome: 'ADVERSE to the Organization.',
    readingState: 'MAJORITY OPINION READ 2026-08-28',
    caveat:
      'THE SIZE OF THE DISCREPANCY DID NOT DECIDE IT - PEPA STACKING DID. A waiver signed two ' +
      'months earlier on an unrelated mileage claim put the member in a 12-month review period, and ' +
      'two Level S violations in two months ended thirteen years of service. THE PRACTICAL WARNING ' +
      'IS ABOUT WAIVERS, NOT ABOUT PAY TICKETS: a signed waiver is a loaded review period. Note ' +
      'also that the award records the member declining to bill 45 minutes of at-home work on the ' +
      'same day, and does not reconcile that with a finding of intent to defraud.',
    document: PLB7303_DOC,
    provenance: PLB7303_PROV,
  },
  {
    id: 'PLB7303-13',
    // Matched against the claim's railroad/agreement. BN and BNSF only.
    appliesTo: /\b(BN|BNSF|Burlington\s+Northern)\b/i,
    // Matched against the violation type and every matched rule label.
    subject: /overtime|calling\s*order|call\s*order|extra\s*list|extra\s*board/i,
    citation: 'Public Law Board No. 7303, Award No. 13 (3 July 2018)',
    board: 'PLB 7303 - Neutral: Robert M. O’Brien; Carrier Member: Jason Ringstad; Employee Member: Matthew L. Burkart (GC, GO-341)',
    // Deliberately describes the DISPUTE, not the holding. See the header.
    subjectMatter:
      'Whether the Right of Appointment rule permits the Carrier to choose who fills a SINGLE-SHIFT ' +
      'overtime vacancy, rather than filling it from the overtime list in calling order.',
    outcome: 'ADVERSE to the Organization - on a NON-HOLIDAY.',
    readingState: 'MAJORITY OPINION READ 2026-08-27',
    caveat:
      'The majority opinion HAS a stated limit and it is favourable: the award says Rule 8K "also ' +
      'applies to all Yardmasters on holidays. It does not apply to ROA Yardmasters on ' +
      'non-holidays." So this authority reaches an ROA overtime claim on a NON-holiday and does ' +
      'not reach one on a holiday. Check whether the date of occurrence was a holiday before ' +
      'treating this as adverse. The text of Rules 7F and 8K themselves has NOT been read in the ' +
      'BN schedule - everything here is the board’s characterisation of them.',
    document: 'data\\PLB7303_Awards_6-13_with_dissents.pdf',
    dissent: 'data\\PLB7303_Dissents_11_and_13.pdf',
    provenance: 'Supplied by M. Burkart, GC GO-341, 2026-08-24. Filed 2026-08-25.',
  },
  {
    id: 'PLB7303-11',
    appliesTo: /\b(BN|BNSF|Burlington\s+Northern)\b/i,
    subject: /rest\s*day|seniority|senior\s+yardmaster|position\s+assignment|3\s*-?\s*G\b/i,
    citation: 'Public Law Board No. 7303, Award No. 11 (3 July 2018)',
    board: 'PLB 7303 - Neutral: Robert M. O’Brien; Carrier Member: Jason Ringstad; Employee Member: Matthew L. Burkart (GC, GO-341)',
    subjectMatter:
      'Whether the Carrier may place a senior Yardmaster on any position within a Terminal, against ' +
      'the Yardmasters’ Agreement reservation of rest-day choice to the senior Yardmaster.',
    outcome: 'ADVERSE to the Organization.',
    readingState: 'MAJORITY OPINION READ 2026-08-27',
    caveat:
      'THE RULE NUMBER IS UNRESOLVED AND IS NOT ASSERTED. The majority opinion says the ' +
      'Organization relied on "Rule 3B."; the Labor Members’ Dissent says "Rule 3G". 3B and 3G ' +
      'are not the same rule and both readings came off a rotated scan. Do not cite either until ' +
      'the BN schedule is opened at Rule 3. The majority denied this claim on Carrier discretion ' +
      'over Right of Appointment positions under Rule 7, NOT by "nullifying Rule 3G" - that is ' +
      'the dissent’s characterisation.',
    document: 'data\\PLB7303_Awards_6-13_with_dissents.pdf',
    dissent: 'data\\PLB7303_Dissents_11_and_13.pdf',
    provenance: 'Supplied by M. Burkart, GC GO-341, 2026-08-24. Filed 2026-08-25.',
  },
];
